
<ag-charts *ngIf="isPageReady"  [options]="options"  style="width: 100%; height: 100%; display: block"></ag-charts>>
